'use client';

import { useEffect } from 'react';

import { useAnalytics } from './useAnalytics';

interface AnalyticsGroupInput {
  id: string;
  site_name: string;
  tenant_id: string;
}

export const useAnalyticsGroupSync = (group?: AnalyticsGroupInput) => {
  const { setGroup } = useAnalytics();

  useEffect(() => {
    if (!group?.id) return;

    setGroup({
      type: 'SaaS_site',
      id: group.id,
      properties: {
        site_name: group.site_name,
        tenant_id: group.tenant_id,
      },
    });
  }, [group, setGroup]);
};
